<template>
  <div class="d-flex-column justify-start align-start gap-20">
    <div class="d-flex-column justify-start align-start gap-5">
      <h4 class="t-white font-family-1 title-h5 f-w-600">
        {{ $t("path_of_exile.extra_divine_orbs") }}
      </h4>
      <p class="t-grey font-family-2 regular-l">
        {{ $t("path_of_exile.extra_divine_orbs_help") }}
      </p>
    </div>

    <div class="orb_picker d-flex-row justify-start flex-wrap b-radius-12">
      <div class="picker_option_container justify-start flex-wrap">
        <button
          v-for="option in divineOrbsOptions"
          class="role_picker d-flex-row space-between gap-5 medium-l font-family-2"
          :key="option.id"
          :class="[isOptionSelected(option.id) && 'selected']"
          @click.stop="() => selectChildOption(option)"
        >
          <div class="d-flex-row justify-start">
            <img
              src="/images/games/path-of-exile-2-boost/currencies/divine_orb.webp"
              class="divine_orb_image"
            />
            <p class="t-white medium-l font-family-2">
              {{ option.title }}
            </p>
          </div>
          <h4 class="font-family-2 caps regular-s t-blue">
            {{ renderPrice(option) }}
          </h4>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { calculateCurrency } from "~/calculate/calculatePrice";
const { getGamePack } = useGameStore();
const { getUserCurrency } = useUserStore();

const checkoutStore = useCheckoutStore();
const divineOrbsOptions = computed(() => {
  return (
    getGamePack.pack_options?.filter(
      (packOp) =>
        packOp.const_title === "five_divine_orbs" ||
        packOp.const_title === "fifteen_divine_orbs" ||
        packOp.const_title === "thirty_divine_orbs"
    ) || []
  );
});

const isOptionSelected = (packOption) => {
  const selectedOption = checkoutStore.getPackOptions.find(
    (option) => option === packOption
  );
  if (!selectedOption) {
    return false;
  }
  return true;
};

const selectChildOption = (option) => {
  if (!isOptionSelected(option.id)) {
    checkoutStore.removePackOption({
      optionIds: option?.rules?.disable || [],
    });

    checkoutStore.setPackOptions({
      options: [...checkoutStore.getPackOptions, option.id],
    });
  } else {
    const otherOptions = checkoutStore.getPackOptions.filter(
      (packOpt) => packOpt !== option.id
    );

    checkoutStore.setPackOptions({
      options: [...otherOptions],
    });
  }
};

const renderPrice = (packOption) => {
  if (packOption.type === "free") {
    return packOption.type;
  } else if (packOption.type === "variable") {
    return `+${packOption.price}%`;
  } else if (packOption.type === "fixed") {
    return `+${parseFloat(calculateCurrency(packOption.price)).toFixed(
      2
    )}${handleCurrency(getUserCurrency)}`;
  } else if (packOption.type === "custom" && packOption.price === 0) {
    return "Custom";
  } else {
    return `+${packOption.price}`;
  }
};
</script>

<style lang="scss" scoped>
.orb_picker {
  padding: 12px;
  border: 1px solid var(--stroke-medium);
}
.divine_orb_image {
  width: 32px;
  height: 32px;
  border-radius: 2.769px;
  border: 0.308px solid var(--bg-main, #050607);
  object-fit: cover;
}
</style>
